<template>
  <div class="app-container">
    <button
        type="button"
        class="dialog-close-btn"
        @click="$emit('close-modal')"
        aria-label="Close"
        >
        <i class="fa fa-xmark"></i>
    </button>
    <div class="container">
      <div class="header">
        <h1>Loyihalar va Jamoalar</h1>
        <p>Loyihalarni jamoalari bilan bog'lang</p>
      </div>

      <div class="main-grid">
        <!-- CHAP: LOYIHALAR -->
        <div class="section">
          <div class="section-title">
            <span class="icon">📋</span>
            Loyihalar
          </div>
          <div class="projects-container">
            <div
              v-for="project in projects"
              :key="project.id"
              :class="['project-item', { active: selectedProjectId === project.id }]"
              @click="selectProject(project.id)"
            >
              <div class="project-name">{{ project.name }}</div>
              <div class="project-meta">
                <span>{{ project.description }}</span>
                <span
                  class="project-status"
                  :style="getStatusStyle(project.status)"
                >
                  {{ project.status }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- O'NG: JAMOALAR -->
        <div class="section">
          <div class="section-title">
            <span class="icon">👥</span>
            Jamoalar
          </div>
          <div id="teamsContent">
            <div v-if="!selectedProjectId" class="no-selection">
              <div class="no-selection-icon">👈</div>
              <p>Loyihani tanlang</p>
            </div>

            <div v-else class="teams-container">
              <div
                v-for="team in teams"
                :key="team.id"
                :class="[
                  'team-item',
                  { active: selectedProject && selectedProject.teamId === team.id }
                ]"
              >
                <div class="team-info">
                  <div class="team-name">{{ team.icon }} {{ team.name }}</div>
                  <div class="team-members">{{ team.members }}</div>
                </div>
                <button :class="['connect-btn', { connected: selectedProject && selectedProject.teamId === team.id }]"
                  @click="toggleTeamConnection(team.id)"
                >
                  {{
                    selectedProject && selectedProject.teamId === team.id
                      ? '✓ Biriktirgan'
                      : 'Biriktirish'
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectsAndTeams',
  emits: ['close-modal'],
  data() {
    return {
      selectedProjectId: null,
      projects: [
        {
          id: 1,
          name: 'E-Commerce Sayt',
          description: 'Onlayn sotuvlar platformasi',
          status: 'Faol',
          teamId: 1
        },
        {
          id: 2,
          name: 'Mobile Ilovasi',
          description: 'Smartfon ilovasi',
          status: 'Jarayonda',
          teamId: 3
        },
        {
          id: 3,
          name: 'Analytics Dashboard',
          description: "Ma'lumot analitika paneli",
          status: 'Tayyorlangan',
          teamId: 2
        },
        {
          id: 4,
          name: 'CRM Sistema',
          description: 'Misoliy munosabatlar boshqaruvi',
          status: 'Faol',
          teamId: null
        },
        {
          id: 5,
          name: 'AI Chatbot',
          description: "Sun'iy intellekt chatbot",
          status: 'Jarayonda',
          teamId: 2
        },
        {
          id: 6,
          name: 'Blogging Platform',
          description: 'Kontentni boshqarish tizimi',
          status: 'Faol',
          teamId: 1
        }
      ],
      teams: [
        {
          id: 1,
          name: 'Frontend Jamoasi',
          members: "5 a'zo",
          icon: '👨‍💻'
        },
        {
          id: 2,
          name: 'Backend Jamoasi',
          members: "4 a'zo",
          icon: '⚙️'
        },
        {
          id: 3,
          name: 'Mobile Jamoasi',
          members: "3 a'zo",
          icon: '📱'
        },
        {
          id: 4,
          name: 'Design Jamoasi',
          members: "2 a'zo",
          icon: '🎨'
        },
        {
          id: 5,
          name: 'DevOps Jamoasi',
          members: "2 a'zo",
          icon: '🔧'
        }
      ],
      statusColors: {
        Faol: '#e0e7ff',
        Jarayonda: '#fef3c7',
        Tayyorlangan: '#d1fae5'
      },
      statusTextColors: {
        Faol: '#4c51bf',
        Jarayonda: '#92400e',
        Tayyorlangan: '#065f46'
      }
    };
  },
  computed: {
    selectedProject() {
      return this.projects.find(p => p.id === this.selectedProjectId) || null;
    }
  },
  methods: {
    selectProject(projectId) {
      this.selectedProjectId = projectId;
    },
    toggleTeamConnection(teamId) {
      if (this.selectedProject) {
        if (this.selectedProject.teamId === teamId) {
          this.selectedProject.teamId = null;
        } else {
          this.selectedProject.teamId = teamId;
        }
      }
    },
    getStatusStyle(status) {
      return {
        background: this.statusColors[status],
        color: this.statusTextColors[status]
      };
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-container {
  font-family: 'Poppins';
  background: linear-gradient(135deg, #f5f7fa 0%, #f0f2f5 100%);
  width: 100%;
  padding: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: 30px;
}

.header h1 {
  font-size: 2.2em;
  color: #2d3748;
  margin-bottom: 8px;
  font-weight: 600;
}

.header p {
  color: #718096;
  font-size: 1em;
}

.main-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.section-title {
  font-size: 1.15em;
  color: #2d3748;
  margin-bottom: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title .icon {
  font-size: 1.2em;
  opacity: 0.8;
}

/* LOYIHALAR BO'LIMI */
.projects-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 450px;
  overflow-y: auto;
  padding-right: 6px;
}

.projects-container::-webkit-scrollbar {
  width: 5px;
}

.projects-container::-webkit-scrollbar-track {
  background: transparent;
}

.projects-container::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

.projects-container::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.project-item {
  padding: 10px 12px;
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.project-item:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.project-item.active {
  background: linear-gradient(135deg, #e6efff 0%, #f0f4ff 100%);
  border-color: #a5b4fc;
  border-left-color: #6366f1;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.15);
}

.project-name {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9em;
  margin-bottom: 3px;
  text-align: left;
}

.project-meta {
  font-size: 0.75em;
  color: #a0aec0;
  display: flex;
  gap: 8px;
}

.project-status {
  display: inline-block;
  padding: 2px 8px;
  background: #e0e7ff;
  color: #4c51bf;
  border-radius: 4px;
  font-size: 0.7em;
  font-weight: 600;
}

/* JAMOALAR BO'LIMI */
.teams-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 450px;
  overflow-y: auto;
  padding-right: 6px;
}

.teams-container::-webkit-scrollbar {
  width: 5px;
}

.teams-container::-webkit-scrollbar-track {
  background: transparent;
}

.teams-container::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

.teams-container::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.team-item {
  padding: 10px 12px;
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.team-item:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.team-item.active {
  background: linear-gradient(135deg, #fef3c7 0%, #fef9e7 100%);
  border-color: #fcd34d;
  border-left-color: #f59e0b;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
}

.team-info {
  flex: 1;
}

.team-name {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9em;
  margin-bottom: 2px;
}

.team-members {
  font-size: 0.75em;
  color: #a0aec0;
}

.connect-btn {
  padding: 6px 12px;
  background: #f0f4ff;
  color: #6366f1;
  border: 2px solid #c7d2fe;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.8em;
  transition: all 0.2s ease;
  white-space: nowrap;
  margin-left: 8px;
}

.connect-btn:hover {
  background: #e0e7ff;
  border-color: #a5b4fc;
}

.team-item.active .connect-btn {
  background: #fef3c7;
  color: #d97706;
  border-color: #fcd34d;
}

.team-item.active .connect-btn:hover {
  background: #fde68a;
}

.connect-btn.connected {
  background: linear-gradient(135deg, #d1fae5, #ecfdf5);
  color: #059669;
  border-color: #a7f3d0;
}

.connect-btn.connected:hover {
  background: linear-gradient(135deg, #a7f3d0, #d1fae5);
}

.no-selection {
  text-align: center;
  padding: 40px 20px;
  color: #a0aec0;
}

.no-selection-icon {
  font-size: 2.5em;
  margin-bottom: 12px;
  opacity: 0.5;
}

@media (max-width: 1024px) {
  .main-grid {
    grid-template-columns: 1fr;
  }

  .projects-container,
  .teams-container {
    max-height: 350px;
  }
}

/* ANIMATION */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.project-item,
.team-item {
  animation: slideIn 0.3s ease;
}

/* Soft colors palette */
:root {
  --color-primary-light: #e0e7ff;
  --color-primary: #6366f1;
  --color-secondary-light: #fef3c7;
  --color-secondary: #f59e0b;
  --color-success-light: #d1fae5;
  --color-success: #059669;
}

.exit-button {

}

.dialog-close-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 0.9);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
  font-size: 15px;
  line-height: 1;
  padding: 0;
}

:root[data-bs-theme='dark'] .dialog-close-btn {
  background: rgba(10, 10, 20, 0.95);
  border-color: rgba(255, 255, 255, 0.18);
  color: #f5f5ff;
}

.dialog-close-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(15, 34, 58, 0.25);
}
</style>